/** 由 scripts/copy-ort-wasm.mjs 自动生成，请勿手改 */
export default '4.2.0';
